import {Directive, OnChanges, SimpleChanges, ElementRef, Input} from '@angular/core';

declare var Chart:any;

@Directive({
  selector: '[lastYearGraph]'
})

export class LastYieldDirective {
  @Input() line1Label:string = "";
  @Input() line1Data:number[];
  @Input() line2Label:string = "";
  @Input() line2Data:number[];
  @Input() line3Label:string = "";
  @Input() line3Data:number[];
  @Input() line4Label:string = "";
  @Input() line4Data:number[];

  el:any;
  myChart:any;
  afterInit:boolean = false;

  constructor(element:ElementRef) {
    this.el = element.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.afterInit) {
      //console.log(changes.hasOwnProperty('line3Data'));
      console.log("*********");
      console.log(this.myChart.data.datasets)
      console.log("*********");

      if (changes.hasOwnProperty('line1Label')) {
        this.myChart.data.datasets[0].label = changes['line1Label'].currentValue;
      }
      if (changes.hasOwnProperty('line1Data')) {
        this.myChart.data.datasets[0].data = changes['line1Data'].currentValue;
      }

      if (changes.hasOwnProperty('line2Label')) {
        if(!this.myChart.data.datasets[1]){
          this.myChart.data.datasets.push({
            label: changes['line2Label'].currentValue,
            data: changes['line2Data'].currentValue,
            lineTension: 0,            
            borderColor: "rgba(204,0,0,.8)",
            backgroundColor: "rgba(204,0,0,0)",
            hoverBackgroundColor: "rgba(204,0,0,1)",
            borderWidth: 1,
            pointBorderColor: "rgba(204,0,0,1)",
            pointBackgroundColor: "rgba(255,255,255,.8)",
            pointBorderWidth: 2,
            yAxisID: "y-axis-1",
          });
        }
      }
      if (changes.hasOwnProperty('line2Data')) {
        this.myChart.data.datasets[1].data = changes['line2Data'].currentValue;
      }

      if (changes.hasOwnProperty('line3Label')) {
        if(!this.myChart.data.datasets[2]){
          this.myChart.data.datasets.push({
            label: changes['line3Label'].currentValue,
            data: changes['line3Data'].currentValue,
            lineTension: 0,
            borderColor: "rgba(2,117,219,.8)",
            backgroundColor: "rgba(2,117,219,0)",
            hoverBackgroundColor: "rgba(2,117,219,1)",
            borderWidth: 1,
            pointBorderColor: "rgba(2,117,219,1)",
            pointBackgroundColor: "rgba(255,255,255,.8)",
            pointBorderWidth: 2,
            yAxisID: "y-axis-1",
          });
        }
      }
      if (changes.hasOwnProperty('line3Data')) {
        this.myChart.data.datasets[2].data = changes['line3Data'].currentValue;
      }

      if (changes.hasOwnProperty('line4Label')) {
        if(!this.myChart.data.datasets[3]){
          this.myChart.data.datasets.push({
            label: changes['line4Label'].currentValue,
            data: changes['line4Data'].currentValue,
            lineTension: 0,
            borderColor: "rgba(2,117,219,.8)",
            backgroundColor: "rgba(2,117,219,0)",
            hoverBackgroundColor: "rgba(2,117,219,1)",
            borderWidth: 1,
            pointBorderColor: "rgba(2,117,219,1)",
            pointBackgroundColor: "rgba(255,255,255,.8)",
            pointBorderWidth: 2,
            yAxisID: "y-axis-1",
          });
        }
      }
      if (changes.hasOwnProperty('line4Data')) {
        this.myChart.data.datasets[3].data = changes['line4Data'].currentValue;
      }


      this.myChart.update();
    }
  }

  ngAfterViewInit() {
    this.afterInit = true;
    this.buildChart();
  }
  
  private buildChart() {
    var canvas = this.el;
    var ctx = canvas.getContext('2d');
    ctx.canvas.height = 234;

    console.log("*********");
    console.log(this.line1Label);
    console.log(this.line2Label);
    console.log(this.line3Label);
    console.log(this.line4Label);
    console.log(this.line1Data);
    console.log(this.line2Data);
    console.log(this.line3Data);
    console.log(this.line4Data);
    console.log("*********");

    var _data = {
      labels: ['FF', '3m', '6m', '1y', '2yr', '5yr', '10yr', '30yr'],
      datasets: [{
        label: this.line1Label,
        data: this.line1Data,
        lineTension: 0,
        borderColor: "rgba(153,204,51,.8)",
        backgroundColor: "rgba(153,204,51,0)",
        hoverBackgroundColor: "rgba(153,204,51,1)",
        borderWidth: 1,
        pointBorderColor: "rgba(153,204,51,1)",
        pointBackgroundColor: "rgba(255,255,255,.8)",
        pointBorderWidth: 2,
        yAxisID: "y-axis-1",
      }]
    };

    
    if(this.line2Label){
      console.log("HAS LABEL 2 : " + this.line2Label);
      _data.datasets.push({
        label: this.line2Label,
        data: this.line2Data,
        lineTension: 0,
        borderColor: "rgba(204,0,0,.8)",
        backgroundColor: "rgba(204,0,0,0)",
        hoverBackgroundColor: "rgba(204,0,0,1)",
        borderWidth: 1,
        pointBorderColor: "rgba(204,0,0,1)",
        pointBackgroundColor: "rgba(255,255,255,.8)",
        pointBorderWidth: 2,
        yAxisID: "y-axis-1",
      });
    }
    
    if(this.line3Label){
      console.log("HAS LABEL 3 : " + this.line3Label);
      _data.datasets.push({
        label: this.line3Label,
        data: this.line3Data,
        lineTension: 0,
        borderColor: "rgba(2,117,219,.8)",
        backgroundColor: "rgba(2,117,219,0)",
        hoverBackgroundColor: "rgba(2,117,219,1)",
        borderWidth: 1,
        pointBorderColor: "rgba(2,117,219,1)",
        pointBackgroundColor: "rgba(255,255,255,.8)",
        pointBorderWidth: 2,
        yAxisID: "y-axis-1",
      });
    }
    
    if(this.line4Label){
      console.log("HAS LABEL 4 : " + this.line4Label);
      _data.datasets.push({
        label: this.line4Label,
        data: this.line4Data,
        lineTension: 0,
        borderColor: "rgba(2,117,219,.8)",
        backgroundColor: "rgba(2,117,219,0)",
        hoverBackgroundColor: "rgba(2,117,219,1)",
        borderWidth: 1,
        pointBorderColor: "rgba(2,117,219,1)",
        pointBackgroundColor: "rgba(255,255,255,.8)",
        pointBorderWidth: 2,
        yAxisID: "y-axis-1",
      });
    }

    var _options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          categorySpacing: 0
        }],
        yAxes: [{
          type: "linear",
          display: true,
          position: "left",
          id: "y-axis-1"
        }]
      }
    };

    this.myChart = new Chart(ctx, {
      type: "line",
      data: _data,
      options: _options
    });

    console.log("********");
    console.log(this.myChart.data);
    console.log("********");
    
    //console.log(ctx);
    //console.log(this.myChart);
  }
}


// WEBPACK FOOTER //
// ./src/app/game/last-yield.directive.ts